import Settings from "./screens/settings";
import Campaigns from "./screens/campaigns";

export const wpPageMap: {
	[wpPage: string]: {
		pageTitle: string;
		page: JSX.Element;
		layoutFixed: boolean;
	};
} = {
	messageflow: {
		pageTitle: "Settings",
		page: <Settings />,
		layoutFixed: false,
	},
	messageflow_campaigns: {
		pageTitle: "Campaigns",
		page: <Campaigns />,
		layoutFixed: true,
	},
};
